import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import clearCardReducer, { clearCardDataApi } from './clearCard';
import clueReducer, { clueDataApi } from './clue';
import external from './external';
import keywordReducer, { keywordDataApi } from './keyword';
import missionKeywordReducer, { missionKeywordDataApi } from './missionKeyword';
import liffUser from './liffUser';
import prizeReducer, { prizeAPI } from './prize';
import profileReducer, { profileAPI } from './profile';
import progressReducer, { progressAPI } from './progress';
import rewardReducer, { rewardDataApi } from './reward';
import { sessionErrorMiddleware } from './sessionErrorMiddleware';
import user, { userDataApi } from './user';
import missionClearCardReducer, { missionClearCardDataApi } from './missionClearCard';

export type AppDispatch = typeof store.dispatch;

/**
 * 複数のリデューサーを結合したルートリデューサーを作成します。
 * @type {import('@reduxjs/toolkit').Reducer<import('./award').State & import('./external').State & import('./user').State>}
 */
const reducer = combineReducers({
  external,
  user,
  progress: progressReducer,
  keyword: keywordReducer,
  missionKeyword: missionKeywordReducer,
  clue: clueReducer,
  profile: profileReducer,
  clearCard: clearCardReducer,
  missionClearCard: missionClearCardReducer,
  prize: prizeReducer,
  reward: rewardReducer,
  liffUser,
  [userDataApi.reducerPath]: userDataApi.reducer,
  [progressAPI.reducerPath]: progressAPI.reducer,
  [keywordDataApi.reducerPath]: keywordDataApi.reducer,
  [missionKeywordDataApi.reducerPath]: missionKeywordDataApi.reducer,
  [clueDataApi.reducerPath]: clueDataApi.reducer,
  [profileAPI.reducerPath]: profileAPI.reducer,
  [missionClearCardDataApi.reducerPath]: missionClearCardDataApi.reducer,
  [clearCardDataApi.reducerPath]: clearCardDataApi.reducer,
  [prizeAPI.reducerPath]: prizeAPI.reducer,
  [rewardDataApi.reducerPath]: rewardDataApi.reducer,
});

const middleware = getDefaultMiddleware({ serializableCheck: false }).concat(
  userDataApi.middleware,
  progressAPI.middleware,
  keywordDataApi.middleware,
  missionKeywordDataApi.middleware,
  clueDataApi.middleware,
  profileAPI.middleware,
  clearCardDataApi.middleware,
  missionClearCardDataApi.middleware,
  prizeAPI.middleware,
  rewardDataApi.middleware,
  sessionErrorMiddleware
);

/**
 * デフォルトのミドルウェアを設定したReduxストアを作成します。
 * @type {import('@reduxjs/toolkit').EnhancedStore<import('types').RootState>}
 */
export const store = configureStore({ reducer, middleware });

setupListeners(store.dispatch);

/**
 * RootStateの型定義です。
 * @typedef {ReturnType<typeof reducer>} RootState
 */
export type RootState = ReturnType<typeof reducer>;
